import defaultStyled from 'styled-components';

const PRIMARY_COLOR = '#088482';
const DARY_GRAY_LIGHT = '#5D5D5D';
const DARK_GRAY = '#3F3F3F';
const DARY_GRAY_DARK = '#2D2D2D';
const DARY_GRAY_DARKER = '#1E1E1E';
const WHITE = '#FFF';

export interface VideoDiscoveryTheme {
  primaryColor: string;
  pageBackground: string;
  foreground: string;
  contentBackground: string;
  headerBackground: string;
  inputBackground: string;
  selected: string;
}

export const DEFAULT_THEME: VideoDiscoveryTheme = {
  primaryColor: PRIMARY_COLOR,
  pageBackground: DARY_GRAY_DARKER,
  foreground: WHITE,
  contentBackground: DARY_GRAY_DARK,
  headerBackground: DARK_GRAY,
  inputBackground: DARK_GRAY,
  selected: DARY_GRAY_LIGHT,
};

export const styled = defaultStyled;

export function styledScrollBars(
  options: {
    color?: string;
    backgroundColor?: string;
  } = {},
) {
  const color = options.color || 'rgba(150,150,150,0.5)';
  const backgroundColor = options.backgroundColor || 'transparent';

  return `
    // Firefox
    scrollbar-color: ${color} ${backgroundColor};
    scrollbar-width: auto;

    // Chrome
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 8px;
      border-radius: 0;
    }

    &::-webkit-scrollbar-thumb {
      background: ${color};
      border-radius: 0px;
      border: 0.5px solid ${backgroundColor};
    }

    &::-webkit-scrollbar-track {
      background: ${backgroundColor};
    }
  `;
}
